import { Component, Input } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';

@Component({
  selector: 'app-copy-icon-with-tooltip',
  templateUrl: './copy-icon-with-tooltip.component.html',
  styleUrls: ['./copy-icon-with-tooltip.component.scss'],
})
export class CopyIconWithTooltipComponent {
  @Input() tooltip: string = 'Copied!';
  @Input() icon: string = 'copy-outline';
  @Input() copyText: string = '';
  @Input() iconColor: string;
  disableTooltip: boolean = true;

  constructor(private clipboardService: ClipboardService) {}

  copyToken() {
    this.disableTooltip = false;
    this.clipboardService.copy(this.copyText);
    setTimeout(() => {
      this.disableTooltip = true;
    }, 2000);
  }
}
